<template>
    <div class="show-settings">
        <nav class="show-settings-nav">
            <ul>
                <li v-for="(data, url) in filteredTabs" :key="url">
                    <router-link :to="`/shows/${$route.params.hash}/${url}`">
                        <i :class="`far fa-${data.icon}`" />
                        {{ data.label }}
                    </router-link>
                </li>
            </ul>
        </nav>

        <div class="show-settings-content">
            <router-view
                :show="show"
                :player-embed="playerEmbed"
            />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        show: {
            type: [Object, Boolean],
            default: () => ({}),
        },
        playerEmbed: {
            type: [Boolean, Object],
            default: false,
        },
    },

    data: () => ({
        tabs: {
            settings: {
                label: 'Podcast',
                icon: 'microphone',
            },
            'settings/hosting': {
                label: 'Hosting',
                icon: 'server',
            },
            'settings/branding': {
                label: 'Branding',
                icon: 'paint-brush',
            },
            'settings/directories': {
                label: 'Directories',
                icon: 'album-collection',
                onlyHosted: true,
            },
            'settings/player-settings': {
                label: 'Player Settings',
                icon: 'play-circle',
            },
            'settings/subscribe-links': {
                label: 'Subscribe Links',
                icon: 'share-alt',
            },
            'settings/plan': {
                label: 'Plan',
                icon: 'flag',
            },
        },
    }),

    computed: {
        /**
         * Returns list of filtered tabs.
         *
         * @returns {object} Filtered tabs.
         */
        filteredTabs() {
            const tabs = {};

            for (const url in this.tabs) {
                const tab = this.tabs[url];

                if (! this.show.hosted && tab.onlyHosted) {
                    continue;
                }

                tabs[url] = tab;
            }

            return tabs;
        },
    },
};
</script>
